export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-no-dogs-234f90eba7421f9df9f9f7283f6ca373.svg";